import { netcompanyTheme } from "netcompany-mdx-slide";
import { ImportSlides } from "gatsby-theme-mdx-deck";
import "prismjs/components/prism-java";
import headSlides from "..\\..\\..\\..\\..\\..\\slides\\head.mdx";
import introductionSlides from "..\\..\\..\\..\\..\\..\\slides\\introduction.mdx";
import programmingParadigmsSlides from "..\\..\\..\\..\\..\\..\\slides\\programming-paradigms.mdx";
import oop_101Slides from "..\\..\\..\\..\\..\\..\\slides\\oop-101.mdx";
import caseStudyContextSlides from "..\\..\\..\\..\\..\\..\\slides\\case-study-context.mdx";
import caseStudyAbstractionSlides from "..\\..\\..\\..\\..\\..\\slides\\case-study-abstraction.mdx";
import caseStudyEncapsulationSlides from "..\\..\\..\\..\\..\\..\\slides\\case-study-encapsulation.mdx";
import caseStudyInheritantSlides from "..\\..\\..\\..\\..\\..\\slides\\case-study-inheritant.mdx";
import caseStudyPolymophismSlides from "..\\..\\..\\..\\..\\..\\slides\\case-study-polymophism.mdx";
import caseStudyConclusionSlides from "..\\..\\..\\..\\..\\..\\slides\\case-study-conclusion.mdx";
import realProjectExamplesSlides from "..\\..\\..\\..\\..\\..\\slides\\real-project-examples.mdx";
import summarySlides from "..\\..\\..\\..\\..\\..\\slides\\summary.mdx";
import endingSlides from "..\\..\\..\\..\\..\\..\\slides\\ending.mdx";
import * as React from 'react';
export default {
  netcompanyTheme: netcompanyTheme,
  ImportSlides: ImportSlides,
  headSlides: headSlides,
  introductionSlides: introductionSlides,
  programmingParadigmsSlides: programmingParadigmsSlides,
  oop_101Slides: oop_101Slides,
  caseStudyContextSlides: caseStudyContextSlides,
  caseStudyAbstractionSlides: caseStudyAbstractionSlides,
  caseStudyEncapsulationSlides: caseStudyEncapsulationSlides,
  caseStudyInheritantSlides: caseStudyInheritantSlides,
  caseStudyPolymophismSlides: caseStudyPolymophismSlides,
  caseStudyConclusionSlides: caseStudyConclusionSlides,
  realProjectExamplesSlides: realProjectExamplesSlides,
  summarySlides: summarySlides,
  endingSlides: endingSlides,
  React: React
};